import React, { useState } from 'react';
import FormQuestion from '../../../networking/models/FormQuestion';
import HanTable, { HanTableCell, HanTableRow } from './HanTable';
import { ReactComponent as ChevronDownPink } from '../../../assets/icons/icon_chevron_down_pink.svg';
import { ReactComponent as ChevronUpPink } from '../../../assets/icons/icon_chevron_up_pink.svg';

interface IProps {
    question: FormQuestion;
}

const FormQuestionTable: React.FC<IProps> = ({ question }) => {
    const initialAmount = 3;

    const [answerAmount, setAnswerAmount] = useState<number>(initialAmount);

    const showLess = () => setAnswerAmount(initialAmount);

    switch (question.question_type) {
        case 'yes-no':
            return (
                <>
                    <HanTable borderOrientation="vertical">
                        <HanTableRow>
                            <HanTableCell>Yes</HanTableCell>
                            <HanTableCell>No</HanTableCell>
                        </HanTableRow>

                        <HanTableRow modifiers={["alabaster"]}>
                            <HanTableCell>{question.answers[0].value}</HanTableCell>
                            <HanTableCell>{question.answers[1].value}</HanTableCell>
                        </HanTableRow>
                    </HanTable>
                    <br />
                </>
            );
        case 'open':
        case 'open-with-number':
            const isNumbered = question.question_type === 'open-with-number';

            return (
                <>
                    <HanTable borderOrientation={isNumbered ? 'vertical' : 'horizontal'}>
                        {
                            question.answers.map((answer, index) => {
                                if(index >= answerAmount) return null;

                                return (
                                    <HanTableRow
                                        modifiers={[index % 2 === 0 ? "": "alabaster"]}
                                        key={index}>
                                        { isNumbered && (
                                            <HanTableCell modifiers={isNumbered ? ['left', 'full-width'] : []}>{answer.label}</HanTableCell>
                                        ) }

                                        <HanTableCell>{answer.value}</HanTableCell>
                                    </HanTableRow>
                                )
                            })
                        }
                    </HanTable>

                    {
                        initialAmount < question.answers.length ?
                            answerAmount < question.answers.length ?
                                <p
                                    className="university-general__show-more"
                                    onClick={() =>
                                        answerAmount + 3 < question.answers.length ?
                                            setAnswerAmount(answerAmount + 3) :
                                            setAnswerAmount(question.answers.length)
                                    }
                                >
                                    Show more <ChevronDownPink />
                                </p>
                                :
                                answerAmount >= question.answers.length &&
                                <p
                                    className="university-general__show-more"
                                    onClick={showLess}
                                >
                                    Show less <ChevronUpPink />
                                </p>
                            :
                            <></>
                    }
                    <br></br>
                </>
            );
        case 'high-low':
            return (
                <>
                    <HanTable borderOrientation="vertical">
                        <HanTableRow>
                            <HanTableCell>Very low</HanTableCell>
                            <HanTableCell>Low</HanTableCell>
                            <HanTableCell>Neutral</HanTableCell>
                            <HanTableCell>High</HanTableCell>
                            <HanTableCell>Very high</HanTableCell>
                        </HanTableRow>
                        <HanTableRow modifiers={"alabaster"}>
                            {
                                question.answers.map((answer, index) =>
                                    <HanTableCell key={index}>{answer.value}</HanTableCell>
                                )
                            }
                        </HanTableRow>
                    </HanTable>
                    <br></br>
                </>
            );
        default: return <></>
    }
}

export default FormQuestionTable;
